import { UploadForm } from '@/features/uploads/components/UploadForm';

export function UploadNewPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Upload a file</h1>
      <UploadForm />
    </div>
  );
}
